import Sortable from "sortablejs";

export function sortableList(args) {
  const { initialOrder, elId = "sortable-list", data } = args;

  return {
    data,
    order: initialOrder,
    init() {
      const sortableList = document.getElementById(elId);
      const self = this;

      if (!sortableList) return;

      new Sortable(sortableList, {
        animation: 150,
        handle: ".sortable-handle",
        preventOnFilter: false,
        onEnd: function () {
          const items = Array.from(sortableList.querySelectorAll(".item"));

          const order = items.map((item) => item.dataset.id);

          console.log(order);
          self.order = order;
        },
      });
    },
  };
}
